import { useCallback } from 'react'
import { useCrudSelection } from '@/atoms'

export function useOnSelectUser() {
  const [, setSelection] = useCrudSelection('users')

  return useCallback(({ newSelectedIds }) => setSelection(newSelectedIds), [setSelection])
}
